import sanityClient from '@sanity/client'

export default sanityClient({
    projectId: "a7uxaehp",
    dataset:"production"
})

